import { render, staticRenderFns } from "./PricingPageSkeletonLoader.vue?vue&type=template&id=81012b32&scoped=true&"
import script from "./PricingPageSkeletonLoader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PricingPageSkeletonLoader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PricingPageSkeletonLoader.vue?vue&type=style&index=0&id=81012b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81012b32",
  null
  
)

export default component.exports